import { Promo, RaceProgram } from "@tvg/ts-types/Race";
import { isFullURL, buildPromoBadgeURL } from "@tvg/formatter/url";
import { get } from "lodash";

export const isPromoExternal = ({
  promos,
  oldPromosURLs
}: {
  promos: Promo | null;
  oldPromosURLs: string[];
}) => {
  let isExternal: boolean = false;
  const promoPath = get(promos, "promoPath", "");

  if (promos) {
    isExternal = isFullURL(promoPath);
    if (isExternal) {
      const urlObject = new URL(promoPath);
      const isOldPromotion = oldPromosURLs.some((oldPromoURL) =>
        oldPromoURL.includes(urlObject.pathname)
      );
      // full URL is not included in old promos, must be parsed
      if (!isOldPromotion) {
        isExternal = false;
        promos.promoPath = urlObject.pathname;
      }
    } else {
      const isOldPromotion = oldPromosURLs.some((oldPromoURL) =>
        oldPromoURL.includes(promoPath)
      );
      // not a full URL but it's an old promo, must be changed to full url
      if (isOldPromotion) {
        isExternal = true;
        promos.promoPath = `${window.location.origin + promos.promoPath}`;
      }
    }
  }
  return isExternal;
};

export const getPromoUrl = (
  isExternal: boolean,
  promos: Promo,
  race: RaceProgram,
  isMobile: boolean
) =>
  isExternal || !isMobile
    ? promos?.promoPath || "/promos"
    : buildPromoBadgeURL(promos?.promoPath, get(race, "raceNumber", "1"));
